export const PROGRESS_VARIANTS = [
    { id: 'ring', label: 'Ring', icon: 'fas fa-circle-notch' },
    { id: 'semi-ring', label: 'Semi Ring', icon: 'fas fa-adjust' },
    { id: 'linear-bar', label: 'Linear Bar', icon: 'fas fa-align-left' },
    { id: 'vertical-bar', label: 'Vertical Bar', icon: 'fas fa-thermometer-half' },
    { id: 'stepped', label: 'Stepped', icon: 'fas fa-stairs' },
    { id: 'dial', label: 'Dial', icon: 'fas fa-tachometer-alt' },
    { id: 'concentric', label: 'Concentric Rings', icon: 'fas fa-bullseye' },
    { id: 'liquid-fill', label: 'Liquid Fill', icon: 'fas fa-fill-drip' },
    { id: 'badge-percent', label: 'Percent Badge', icon: 'fas fa-percentage' },
    { id: 'checklist', label: 'Checklist', icon: 'fas fa-list-check' },
];
